import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

export function GoogleIcon(props: IconProps): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M12 8v8" />
      <path d="M17.5 12H12" />
      <path d="M12 12H6.5" />
      <path d="M12 2a10 10 0 0 1 7.07 2.93" />
      <path d="M17.5 12a5.5 5.5 0 0 0-5.5-5.5" />
    </svg>
  );
}

export function GitLabIcon(props: IconProps): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="m22 13.29-3.33-10a.42.42 0 0 0-.14-.18.38.38 0 0 0-.22-.11.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18l-2.26 6.67H8.32L6.06 3.25a.42.42 0 0 0-.14-.18.38.38 0 0 0-.23-.07.39.39 0 0 0-.22.11.42.42 0 0 0-.14.18L2 13.29a.74.74 0 0 0 .27.83L12 21l9.69-6.88a.71.71 0 0 0 .31-.83Z" />
    </svg>
  );
}

export function BitbucketIcon(props: IconProps): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M3.27 4.13A.5.5 0 0 1 3.75 3.5h16.5a.5.5 0 0 1 .5.57l-2.38 14.3a.5.5 0 0 1-.49.43H6.12a.68.68 0 0 1-.67-.57L3.27 4.13Z" />
      <path d="M14.5 15h-5l-1-6h7l-1 6Z" />
    </svg>
  );
}
